<template>
  <ContentWrapper>
    <div class="content-heading">
      <div>회원정보</div>
      <!-- Breadcrumb right aligned-->
      <ol class="breadcrumb ml-auto">
        <li class="breadcrumb-item">
          <a href="#">Home</a>
        </li>
        <li class="breadcrumb-item">
          <a href="#">계정관리</a>
        </li>
        <li class="breadcrumb-item active">회원관리</li>
      </ol>
    </div>
    <!-- 검색 -->
    <div class="card card-default">
      <div class="card-body">
        <div class="form-row align-items-center">
          <!-- 기간검색 -->
          <sch-date-rage label="등록일" :data="data"/>

          <!-- 항목 검색 -->
          <sch-text label="검색어" :data="data" @search="search" @reset="reset"/>
        </div>
      </div>
    </div>
    <!-- // 검색-->

    <!-- 목록 -->
    <div v-show="data.params.mode!='detail'" class="card card-default">
      <div class="card-header">
        목록
        <div class="card-tool float-right">
          <b-button @click="dataAction.newItem()" class="btn btn-xs btn-outline-info mr-2" variant="outline-primary">
            New
          </b-button>
        </div>
      </div>
      <div class="card-body">
        <table class="table table-striped table-bordered table-hover">
          <thead>
          <tr>
            <td @click="dataAction.sort(search,'user_id')">사용자ID<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <td @click="dataAction.sort(search,'user_nm')">사용자명<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <td @click="dataAction.sort(search,'sex')">성별<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <td @click="dataAction.sort(search,'tel_no')">전화번호<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <td @click="dataAction.sort(search,'phone_no')">휴대폰번호<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <td @click="dataAction.sort(search,'email')">이메일<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <td @click="dataAction.sort(search,'last_login_dt')">마지막로그인일시<em class="fa-2s mr-2 fas fa-sort"></em></td>
            <td width="80">Action</td>
          </tr>
          </thead>

          <tbody>
          <tr v-show="data.count==0" class="text-center">
            <td colspan="8">No matching records</td>
          </tr>
          <tr v-for="(item, index) in data.list" :key="index">
            <td>{{ item.userId }}</td>
            <td>{{ item.userNm }}</td>

            <td>{{ item.sex }}</td>
            <td>{{ item.telNo }}</td>
            <td>{{ item.phoneNo }}</td>
            <td>{{ item.email }}</td>


            <td>{{ item.lastLoginDt }}</td>

            <td>
              <div>
                <b-btn variant="outline-info mr-2" class="btn btn-sm btn-secondary" @click.prevent="edit(item)"><em class="fa fa-search"></em></b-btn>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="card-footer">
        <div class="d-flex">
          <!--paging component-->
          <Pagenation :data="data" @next="dataAction.next(search)" @prev="dataAction.prev(search)"
                      @first="dataAction.first(search)" @last="dataAction.last(search)" :key="data.params.page"/>
        </div>
      </div>
    </div>
    <!-- // 목록 -->


    <!-- 상세 -->
    <div v-show="data.params.mode=='detail'" class="card card-default">
      <!--<div class="card-header">상세</div>-->
      <div class="card-body">
        <form>
          <input type="hidden" v-model="data.row.adminSeq"/>
          <table class="table table-bordered">
            <colgroup>
              <col width="15%" class="bg-lightdark"/>
              <col width="35%"/>
              <col width="15%" class="bg-lightdark"/>
              <col width="35%"/>
            </colgroup>
            <tr>
              <th>사용자시퀀스</th>
              <td>
                <input type="text" v-model="data.row.userSeq" placeholder="userSeq" class="form-control"
                       style="width: 200px"/>
              </td>
              <th>사용자명</th>
              <td>
                <input type="text" v-model="data.row.userNm" placeholder="userNm" class="form-control"
                       style="width: 200px"/>
              </td>
            </tr>
            <tr>
              <th>사용자ID</th>
              <td>
                <input type="text" v-model="data.row.userId" placeholder="userId" class="form-control"
                       style="width: 200px"/>
              </td>
              <th>사용자 패스워드</th>
              <td>
                <input type="text" v-model="data.row.userPwd" placeholder="userPwd" class="form-control"
                       style="width: 200px"/>
              </td>
            </tr>

            <tr>
              <th>전화번호</th>
              <td>
                <input type="text" v-model="data.row.telNo" placeholder="telNo" class="form-control"
                       style="width: 200px"/>
              </td>
              <td colspan="3">
              </td>
            </tr>
            <tr>
              <th>휴대폰번호</th>
              <td>
                <input type="text" v-model="data.row.phoneNo" placeholder="phoneNo" class="form-control"
                       style="width: 200px"/>
              </td>
              <td colspan="3">
              </td>
            </tr>
            <tr>
              <th>이메일</th>
              <td>
                <input type="text" v-model="data.row.email" placeholder="email" class="form-control"
                       style="width: 200px"/>
              </td>
              <th>성별</th>
              <td>
                <input type="text" v-model="data.row.sex" placeholder="sex" class="form-control" style="width: 200px"/>
              </td>
            </tr>

            <tr>
              <th>우편번호</th>
              <td>
                <input type="text" v-model="data.row.zipCd" placeholder="zipCd" class="form-control"
                       style="width: 200px"/>
              </td>
              <th>생년월일</th>
              <td>
                <input type="text" v-model="data.row.birthDay" placeholder="birthDay" class="form-control"
                       style="width: 200px"/>
              </td>
            </tr>
            <tr>
              <th>주소1</th>
              <td>
                <input type="text" v-model="data.row.addr1" placeholder="addr1" class="form-control"
                       style="width: 200px"/>
              </td>
              <th>주소2</th>
              <td>
                <input type="text" v-model="data.row.addr2" placeholder="addr2" class="form-control"
                       style="width: 200px"/>
              </td>
            </tr>

            <tr>
              <th>마지막로그인일시</th>
              <td>
                <input type="text" v-model="data.row.lastLoginDt" placeholder="lastLoginDt" class="form-control"
                       style="width: 200px" readonly/>
              </td>
              <td colspan="3">
              </td>
            </tr>
            <tr>
              <th>사이트코드</th>
              <td>
                <input type="text" v-model="data.row.siteCd" placeholder="siteCd" class="form-control"
                       style="width: 200px"/>
              </td>
              <td colspan="3">
              </td>
            </tr>
            <tr>
              <th>채널코드</th>
              <td>
                <input type="text" v-model="data.row.channelCd" placeholder="channelCd" class="form-control"
                       style="width: 200px"/>
              </td>
              <td colspan="3">
              </td>
            </tr>
            <tr>
              <th>프로바이더코드</th>
              <td>
                <input type="text" v-model="data.row.providerCd" placeholder="providerCd" class="form-control"
                       style="width: 200px"/>
              </td>
              <td colspan="3">
              </td>
            </tr>
            <tr>
              <th>회원구분코드</th>
              <td>
                <input type="text" v-model="data.row.userTypeCd" placeholder="userTypeCd" class="form-control"
                       style="width: 200px"/>
              </td>
              <td colspan="3">
              </td>
            </tr>
            <tr>
              <th>회원상태코드</th>
              <td>
                <input type="text" v-model="data.row.userStatCd" placeholder="userStatCd" class="form-control"
                       style="width: 200px"/>
              </td>
              <td colspan="3">
              </td>
            </tr>
            <tr>
              <th>등록자ID</th>
              <td>
                <input type="text" v-model="data.row.regId" placeholder="regId" class="form-control"
                       style="width: 200px" readonly/>
              </td>
              <td colspan="3">
              </td>
            </tr>
            <tr>
              <th>등록일시</th>
              <td>
                <input type="text" v-model="data.row.regDt" placeholder="regDt" class="form-control"
                       style="width: 200px"/>
              </td>
              <td colspan="3">
              </td>
            </tr>
            <tr>
              <th>수정자ID</th>
              <td>
                <input type="text" v-model="data.row.updId" placeholder="updId" class="form-control"
                       style="width: 200px"/>
              </td>
              <td colspan="3">
              </td>
            </tr>
            <tr>
              <th>수정일시</th>
              <td>
                <input type="text" v-model="data.row.updDt" placeholder="updDt" class="form-control"
                       style="width: 200px"/>
              </td>
              <td colspan="3">
              </td>
            </tr>

          </table>
        </form>
      </div>

      <div class="card-footer">
        <div class="card-tool float-right">
          <b-button @click="save()" class="btn btn-xs btn-outline-info mr-2" variant="outline-info mr-2">저장</b-button>
          <b-button @click="remove()" class="btn btn-xs btn-outline-info mr-2" variant="outline-info mr-2">삭제</b-button>
          <b-button @click="search()" class="btn btn-xs btn-outline-info mr-2" variant="outline-info mr-2">목록</b-button>
        </div>
      </div>
    </div>
    <!-- // 상세 -->

  </ContentWrapper>
</template>
<script>
import {reactive, ref, computed, onMounted, onUnmounted, onBeforeMount} from '@vue/composition-api'
import {getSsoUserList, getSsoUserItem, saveSsoUser, deleteSsoUser} from "@/api/sso/SsoUserApi";
import Pagenation from "@/components/Common/Pagenation";
import SchDateRange from "../../components/Common/SchDateRange";
import SchText from "../../components/Common/SchText";
import {TableActionClass} from "@/utils/TableActionClass";
import {dataObject} from "@/utils/Constants";
//cfdbe2
export default {
  components: {SchDateRange, SchText, Pagenation},
  setup() {
    const schOptions = [{value: 'name', text: '이름'}, {value: 'admin_id', text: 'ID'}]
    const _dataObject = _.cloneDeep(dataObject);
    const data = reactive(_dataObject)
    data.codes.schOptions = schOptions // 검색 type 선택

    return {
      data,
      ...methods(),
      dataAction: new TableActionClass(data),
    }

  },
}

function methods() {
  var context = {};
  context["getSsoUserList"] = getSsoUserList;  // get list
  context["getSsoUserItem"] = getSsoUserItem;  // get item
  context["deleteSsoUser"] = deleteSsoUser;  // delete item
  context["saveSsoUser"] = saveSsoUser;  // save item

  // 목록
  async function search() {
    let _params = this.data.params
    this.dataAction.execute("getSsoUserList", context, _params);

  }

  // 상세
  async function edit(_params) {
    _params = !_params ? this.data.row : _params
    await this.dataAction.execute("getSsoUserItem", context, _params);
  }

  // 삭제
  async function remove(_params) {
    _params = !_params ? this.data.row : _params
    await this.dataAction.execute("deleteSsoUser", context, _params);
    this.search();
  }

  // 저장
  async function save() {
    let _params = this.data.row
    await this.dataAction.execute("saveSsoUser", context, _params);
    this.search();
  }

  // 초기화
  async function reset() {
    this.data.params.schType = '';
    this.data.params.schText = '';
    this.dataAction.clear();
  }

  return {reset, search, edit, save, remove}
}


</script>